import { useProvideInject } from "../lib/provideInjectGenerator";
import { BetData } from "@fresh8/types/src/betData";
import { AdTag, InSightTesting } from "@fresh8/types/src/index";

export const AdTagSymbol = Symbol("AdTagSymbol");
export const {
  provider: provideAdTag,
  injector: injectAdTag
} = useProvideInject<AdTag>(AdTagSymbol, {} as AdTag);

export const BetDataSymbol = Symbol("BetDataSymbol");
export const {
  provider: provideBetData,
  injector: injectBetData
} = useProvideInject<BetData>(BetDataSymbol, {} as BetData);

export const CarouselSymbol = Symbol("carouselContext");
export const {
  provider: provideCarouselContext,
  injector: injectCarouselContext
} = useProvideInject<{ isCarousel: boolean; itemsOnView: number }>(
  CarouselSymbol,
  {
    isCarousel: false,
    itemsOnView: 0
  }
);

export const InsightTestingSymbol = Symbol("insightTestingContext");
export const {
  provider: provideInsightTestingContext,
  injector: injectInsightTestingContext
} = useProvideInject<InSightTesting>(InsightTestingSymbol, {
  insightRandomTesting: true
});

export const DisplayOverlaySymbol = Symbol("DisplayOverlayContext");
export const {
  provider: provideDisplayOverlay,
  injector: injectDisplayOverlay
} = useProvideInject<boolean>(DisplayOverlaySymbol, false);
